import { BaseRoute, OrganisationCategory } from "@/types/global"

const DetermineBaseRouteByOrganisationCategory = (
  orgCategory:
    | string
    | undefined
    | OrganisationCategory.ACCOUNTANT
    | OrganisationCategory.ASSET_MANAGER
    | OrganisationCategory.ASSET_OWNER
    | OrganisationCategory.CONSULTANT
    | OrganisationCategory.OTHERS
): BaseRoute => {
  switch (orgCategory) {
    case "Consultant":
      return "consultant"
    case "Asset manager":
      return "manager"
    case "Asset owner":
      return "owner"
    case "Others":
      return "client"
    default:
      return "client"
  }
}

export default DetermineBaseRouteByOrganisationCategory
